import LibrariableLinkable from 'src/models/librariable/LibrariableLinkable'
import { ID } from 'src/models/model'
import Concern from 'src/models/model/concerns/Concern'

/**
 * Librariable provides library functionality to a Model.
 */
export default class Librariable extends Concern {
  static librariable = true

  get librariable () {
    return true
  }

  static fields = {
    libraryParentId: {
      type: ID,
      output: true,
      excludeFromDefault: true
    },
    receiveLibraryUpdates: {
      type: Boolean,
      output: true,
      excludeFromDefault: true
    },
    libraryChildSiteIds: {
      type: [ID],
      output: true,
      excludeFromDefault: true
    }
  }

  addOrUpdateLibrariable (libraryParentId) {
    return LibrariableLinkable.addOrUpdateLibrariable(this.typeName, this.id, libraryParentId)
  }

  syncLibrariable () {
    return LibrariableLinkable.syncLibrariable(this.typeName, this.id)
  }

  enableLibrariable () {
    return LibrariableLinkable.enableLibrariable(this.typeName, this.id)
  }

  disableLibrariable () {
    return LibrariableLinkable.disableLibrariable(this.typeName, this.id)
  }

  deleteLibrariable () {
    return LibrariableLinkable.deleteLibrariable(this.typeName, this.id)
  }
}
